"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubNavLinkList = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactDomInteractions = require("@floating-ui/react-dom-interactions");

var _theming = require("@storybook/theming");

var _designSystem = require("@storybook/design-system");

var _styles = require("../shared/styles");

var SubNavLinkListContainer = ( /*#__PURE__*/0, _theming.styled)('nav', process.env.NODE_ENV === "production" ? {
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['inverse'].includes(prop);
  },
  target: "ehxzi2l1"
} : {
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['inverse'].includes(prop);
  },
  target: "ehxzi2l1",
  label: "SubNavLinkListContainer"
})(_styles.text.regular, ";color:", function (props) {
  return props.inverse ? _styles.color.light : _styles.color.dark;
}, ";display:flex;align-items:center;margin-top:10px;margin-bottom:10px;margin-left:auto;a{margin-left:10px;}");
var StyledIcon = ( /*#__PURE__*/0, _theming.styled)(_designSystem.Icon, process.env.NODE_ENV === "production" ? {
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['inverse'].includes(prop);
  },
  target: "ehxzi2l0"
} : {
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['inverse'].includes(prop);
  },
  target: "ehxzi2l0",
  label: "StyledIcon"
})("color:", function (props) {
  return props.inverse ? _styles.color.light : _styles.color.dark;
}, ";");

var SubNavLinkList = function SubNavLinkList(_ref) {
  var label = _ref.label,
      items = _ref.items,
      inverse = _ref.inverse;
  var id = (0, _reactDomInteractions.useId)();
  return /*#__PURE__*/_react["default"].createElement(SubNavLinkListContainer, {
    "aria-labelledby": id,
    inverse: inverse
  }, /*#__PURE__*/_react["default"].createElement("div", {
    id: id
  }, label), items.map(function (item) {
    return /*#__PURE__*/_react["default"].createElement(_designSystem.Link, {
      key: item.label,
      tertiary: true,
      containsIcon: true,
      href: item.href,
      "aria-label": item.label
    }, /*#__PURE__*/_react["default"].createElement(StyledIcon, {
      icon: item.icon,
      "aria-hidden": true,
      inverse: inverse
    }));
  }));
};

exports.SubNavLinkList = SubNavLinkList;